import script from "./AvatarChange.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarChange.vue?vue&type=script&setup=true&lang=js"

import "./AvatarChange.vue?vue&type=style&index=0&id=030a0e14&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-030a0e14"]])

export default __exports__